'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('./../index');

var _reactstrap = require('reactstrap');

var _SubjektTools = require('./SubjektTools');

var SubjektTools = _interopRequireWildcard(_SubjektTools);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Komponenta pro zobrazení informace o úmrtí nebo zániku subjektu.
 */
// --
var SubjektUmrtiInfo = function (_React$Component) {
    (0, _inherits3.default)(SubjektUmrtiInfo, _React$Component);

    function SubjektUmrtiInfo() {
        (0, _classCallCheck3.default)(this, SubjektUmrtiInfo);
        return (0, _possibleConstructorReturn3.default)(this, (SubjektUmrtiInfo.__proto__ || (0, _getPrototypeOf2.default)(SubjektUmrtiInfo)).apply(this, arguments));
    }

    (0, _createClass3.default)(SubjektUmrtiInfo, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                subjekt = _props.subjekt;


            if (!subjekt) {
                return _react2.default.createElement('span', null);
            }

            var deadInfo = SubjektTools.getDeadInfo(subjekt);
            if (deadInfo.dead) {
                return _react2.default.createElement(
                    _reactstrap.Alert,
                    { className: className, color: 'warning' },
                    _react2.default.createElement(
                        _index.DetailLeftIcon,
                        { icon: _react2.default.createElement(_index.Icon, { icon: 'user-times' }) },
                        deadInfo.title
                    )
                );
            } else {
                return _react2.default.createElement('span', null);
            }
        }
    }]);
    return SubjektUmrtiInfo;
}(_react2.default.Component);

SubjektUmrtiInfo.PropTypes = {
    subjekt: _react2.default.PropTypes.object // subjekt
};
exports.default = SubjektUmrtiInfo;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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